import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { LANGUAGES } from '@/constants.js';
import defaultIt from '@/locales/defaultIt.json';
import defaultEn from '@/locales/en.json';
import generatedIt from '@/locales/generated.it.json';
import generatedEn from '@/locales/generated.en.json';
import { listTranslations } from '@/api/api.js';

Vue.use(VueI18n);

const messagesIt = { ...defaultIt, ...generatedIt };
const messagesEn = { ...defaultEn, ...generatedEn };

const _messages = {
  default: messagesIt,
  en: messagesEn,
  it: messagesIt
};

const loadedLanguages = LANGUAGES;
const browserLang = (navigator.language || 'it').split('-')[0].toLowerCase();
const defaultLocale = loadedLanguages.includes(browserLang) ? browserLang : 'it';

export const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'it',
  messages: _messages,
  silentTranslationWarn: true
});

const setI18nLanguage = async lang => {
  const baseMessages = lang === 'en' ? messagesEn : messagesIt;
  const userMessages = { ...baseMessages };

  const resp = await listTranslations(lang);

  resp.data.listTranslations.forEach(translation => {
    userMessages[translation.label_code] = translation.label_value;
  });

  i18n.setLocaleMessage(lang, userMessages);
  i18n.locale = lang;
};

export function loadLanguageAsync(lang) {
  if (loadedLanguages.includes(lang)) {
    return setI18nLanguage(lang);
  }

  return Promise.resolve();
}
